import React from 'react';
import cn from 'classnames';
import * as styles from './styles.module.scss';
import {
  Button,
  IntersectionAnimation,
  LayoutProvider
} from '@mayfield/common/components';
import { FlowerMaskImage } from '@mayfield/website/components';
import { ITeamProfile } from '@mayfield/sanity';
import { useIntersectionAnimation } from '@mayfield/common/hooks';

interface IProps extends ITeamProfile {
  handleBookATourClick: () => void;
  className?: string;
}

const TeamProfileSlide = ({
  image,
  text,
  title,
  handleBookATourClick,
  themeColor,
  className
}: IProps) => {
  const { inView, ref } = useIntersectionAnimation();
  return (
    <div className={cn(styles.container, className)}>
      <LayoutProvider maxWidth padding>
        <div className={styles.grid}>
          <FlowerMaskImage image={image} className={styles.flowerImage} />

          <div className={styles.textContent}>
            <IntersectionAnimation
              className={styles.header}
              trigger={inView}
              delay={200}
            >
              <h2 ref={ref} className={cn('h1')}>
                {title}
              </h2>
            </IntersectionAnimation>
            <IntersectionAnimation
              className={styles.text}
              trigger={inView}
              delay={300}
            >
              <p className={cn('b2')}>{text}</p>
            </IntersectionAnimation>

            <IntersectionAnimation trigger={inView} delay={400}>
              <Button
                color={themeColor}
                theme="lightOnDark"
                onClick={handleBookATourClick}
              >
                Book a Tour
              </Button>
            </IntersectionAnimation>
          </div>
        </div>
      </LayoutProvider>
    </div>
  );
};

export default TeamProfileSlide;
